let pdfLibPromise = null;
function loadPdfLib() {
	if (!pdfLibPromise) {
		pdfLibPromise = import(/* webpackChunkName: "pdf-lib" */ 'pdf-lib');
	}
	return pdfLibPromise;
}
const NAME_SIZE = 14;
let TEXT_COLOR;
const TITLE_SIZE = 8;
const LINE_SIZE = 10;
const LEFT_MARGIN = 56;
const TEXT_BOTTOM_MARGIN = 63;
const LINE_GAP = 4;
const LOGO_MAX_WIDTH = 180;
const LOGO_MAX_HEIGHT = 75;
const LOGO_CENTER_Y = 90;
const RIGHT_MARGIN = 58;

function val(id) {
	const el = document.getElementById(id);
	return el ? (el.value || '').trim() : '';
}

function isOtherSelected() {
	const r = document.getElementById('otherBroker');
	return !!(r && r.checked);
}

function collectBrokerInfo() {
	if (isOtherSelected()) {
		return {
			name: val('otherBrokerName'),
			phone: val('otherBrokerPhone'),
			email: val('otherBrokerEmail'),
		};
	}
	return {
		name: val('selectedBrokerName'),
		phone: val('selectedBrokerPhoneNumber'),
		email: val('selectedBrokerEmail'),
	};
}

function normalizeUrl(url) {
	if (!url) return url;
	try {
		const u = new URL(url, window.location.href);
		if (u.host === window.location.host && u.protocol !== window.location.protocol) {
			u.protocol = window.location.protocol;
		}
		return u.toString();
	} catch (e) {
		return url;
	}
}

async function fetchBytes(url) {
	const res = await fetch(normalizeUrl(url));
	if (!res.ok) throw new Error(`Fetch failed: ${url} (${res.status})`);
	return new Uint8Array(await res.arrayBuffer());
}

async function embedLogo(pdfDoc, url) {
	const bytes = await fetchBytes(url);
	const head = bytes.subarray(0, 4);
	const isPng = head[0] === 0x89 && head[1] === 0x50 && head[2] === 0x4e && head[3] === 0x47;
	return isPng ? pdfDoc.embedPng(bytes) : pdfDoc.embedJpg(bytes);
}

function fitBox(imgW, imgH, maxW, maxH) {
	const scale = Math.min(maxW / imgW, maxH / imgH, 1);
	return { w: imgW * scale, h: imgH * scale };
}

function hexToRgb01(hex) {
	if (!hex) return null;
	const m = /^#?([a-fA-F0-9]{3}|[a-fA-F0-9]{6})$/.exec(hex.trim());
	if (!m) return null;
	let h = m[1];
	if (h.length === 3) h = h.split('').map((c) => c + c).join('');
	return {
		r: parseInt(h.slice(0, 2), 16) / 255,
		g: parseInt(h.slice(2, 4), 16) / 255,
		b: parseInt(h.slice(4, 6), 16) / 255,
	};
}

function downloadBlob(bytes, filename) {
	const blob = new Blob([bytes], { type: 'application/pdf' });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	a.remove();
	setTimeout(() => URL.revokeObjectURL(url), 1000);
}

async function generate(btn) {
	const pdfUrl = btn.dataset.pdfUrl;
	const logoUrl = btn.dataset.logoUrl;
	const logoBgHex = btn.dataset.logoBg || '';
	const websiteUrl = btn.dataset.websiteUrl;
	const brokerTitle = btn.dataset.brokerTitle || '';
	const filenameBase = btn.dataset.filenameBase || 'SimplInsur-Home-AutoMarketingMaterial';

	const leftMargin = btn.dataset.leftMargin ? parseFloat(btn.dataset.leftMargin) : LEFT_MARGIN;
	const rightMargin = btn.dataset.rightMargin ? parseFloat(btn.dataset.rightMargin) : RIGHT_MARGIN;
	const bottomMargin = btn.dataset.bottomMargin ? parseFloat(btn.dataset.bottomMargin) : TEXT_BOTTOM_MARGIN;
	const logoCenterY = btn.dataset.logoCenterY ? parseFloat(btn.dataset.logoCenterY) : LOGO_CENTER_Y;

	if (!pdfUrl) return;

	const broker = collectBrokerInfo();

	const { PDFDocument, StandardFonts, rgb } = await loadPdfLib();
	TEXT_COLOR = rgb(0, 0, 0);

	const templateBytes = await fetchBytes(pdfUrl);

	// Read template dimensions so we can build matching pages in the output doc.
	const srcDoc = await PDFDocument.load(templateBytes);
	const srcPages = srcDoc.getPages();
	const lastIndex = srcPages.length - 1;
	const { width: pageW, height: pageH } = srcPages[lastIndex].getSize();

	// Build the output by stamping each template page as a background on a fresh
	// page, then drawing text/logo on top. This guarantees our overlay ends up
	// above anything the template author placed on its top layer (e.g. a white
	// cover shape used to mask the blank area).
	const outDoc = await PDFDocument.create();
	const embedded = await outDoc.embedPdf(srcDoc);

	const helvetica = await outDoc.embedFont(StandardFonts.Helvetica);
	const helveticaBold = await outDoc.embedFont(StandardFonts.HelveticaBold);

	const lines = [];
	if (broker.name) lines.push({ text: broker.name, size: NAME_SIZE, font: helveticaBold });
	if (brokerTitle) lines.push({ text: brokerTitle.toUpperCase(), size: TITLE_SIZE, font: helvetica });
	if (broker.phone) lines.push({ text: broker.phone, size: LINE_SIZE, font: helvetica });
	if (broker.email) lines.push({ text: broker.email, size: LINE_SIZE, font: helvetica });
	if (websiteUrl) lines.push({ text: websiteUrl, size: LINE_SIZE, font: helvetica });

	let logoImage = null;
	if (logoUrl) {
		try {
			logoImage = await embedLogo(outDoc, logoUrl);
		} catch (e) {
			console.warn('Marketing PDF: logo embed failed', e);
		}
	}

	embedded.forEach((tplPage, i) => {
		const { width, height } = tplPage.size();
		const page = outDoc.addPage([width, height]);
		page.drawPage(tplPage, { x: 0, y: 0, width, height });

		if (i !== lastIndex) return;

		let totalHeight = 0;
		for (const l of lines) totalHeight += l.size + LINE_GAP;
		let cursorY = bottomMargin + totalHeight - LINE_GAP;
		for (const l of lines) {
			cursorY -= l.size;
			page.drawText(l.text, {
				x: leftMargin,
				y: cursorY,
				size: l.size,
				font: l.font,
				color: TEXT_COLOR,
			});
			cursorY -= LINE_GAP;
		}

		if (logoImage) {
			const { w, h } = fitBox(logoImage.width, logoImage.height, LOGO_MAX_WIDTH, LOGO_MAX_HEIGHT);
			const logoX = width - rightMargin - w;
			const logoY = logoCenterY - h / 2;

			const bg = hexToRgb01(logoBgHex);
			if (bg && !(bg.r === 1 && bg.g === 1 && bg.b === 1)) {
				const pad = 6;
				page.drawRectangle({
					x: logoX - pad,
					y: logoY - pad,
					width: w + pad * 2,
					height: h + pad * 2,
					color: rgb(bg.r, bg.g, bg.b),
				});
			}

			page.drawImage(logoImage, {
				x: logoX,
				y: logoY,
				width: w,
				height: h,
			});
		}
	});

	const out = await outDoc.save();
	downloadBlob(out, `${filenameBase}.pdf`);
}

function init() {
	const btn = document.getElementById('marketingPdfBtn');
	if (!btn) return;

	btn.addEventListener('click', async () => {
		if (btn.dataset.busy === '1') return;
		btn.dataset.busy = '1';
		const originalLabel = btn.textContent;
		btn.disabled = true;
		try {
			await generate(btn);
		} catch (e) {
			console.error('Marketing PDF generation failed', e);
		} finally {
			btn.disabled = false;
			btn.textContent = originalLabel;
			btn.dataset.busy = '0';
		}
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
